import React from 'react';
import PropTypes from 'prop-types';
import { Link, Tab, Tabs, Toolbar as ToolbarF7 } from 'framework7-react';

import { I18n } from 'Locales';
import { ColumnView } from 'Containers';
import { QuickFilters } from 'Components';
import { getEffectiveQuickFilters, mockFunction } from 'Helpers';
import { CAMPAIGNS_TYPE, DAILY_FIGURES_TAB_VIEWS, FILTERS, PAGE_NAMES } from 'Constants';

import '../style.scss';
import { Status, DonationAmount } from '../../tableviews';

const tableViews = {
  status: Status,
  donationAmount: DonationAmount
};

const Charity = ({
  adminDailyFigures = {},
  adminFilters = {},
  getAdminDailyFigures = mockFunction,
  transient = {},
  updateDailyFiguresProps = mockFunction,
  updateTransientProps = mockFunction,
  updateUserProps = mockFunction,
  userAdminFilters = {},
  userRole = '',
  view = 'campaignsview'
}) => {
  const {
    dailyFigures = {},
    campaignViewTabs = [],
    currentTableView = DAILY_FIGURES_TAB_VIEWS.STATUS
  } = adminDailyFigures;
  const { getAdminDailyFiguresLoading = false } = transient;

  const effectiveQuickFilters = getEffectiveQuickFilters(
    userAdminFilters,
    adminFilters,
    'dailyFigures',
    CAMPAIGNS_TYPE.FUNDRAISING,
    view
  );

  return (
    <ColumnView id={'campaigns-view'}>
      <QuickFilters
        filtersType={FILTERS.DAILY_FIGURES}
        fetchTableItems={getAdminDailyFigures}
        quickFilters={effectiveQuickFilters}
        role={userRole}
        transient={transient}
        updateTransientProps={updateTransientProps}
        updateUserProps={updateUserProps}
        view={PAGE_NAMES.CAMPAIGNS_VIEW}
      />

      <ToolbarF7 className="navbar-style" position={'top'} tabbar noShadow noHairLine>
        {campaignViewTabs?.map((page, index) => (
          <Link
            key={index}
            tabLink={currentTableView}
            tabLinkActive={page === currentTableView}
            onClick={updateDailyFiguresProps.bind(null, { currentTableView: page })}>
            <span className={`tab-label ${page === currentTableView && 'active'}`}>
              {I18n.t(`admin:campaignsViewTab.${page}`)}
            </span>
          </Link>
        ))}
      </ToolbarF7>

      <Tabs className="w-full h-full">
        {campaignViewTabs?.map((page, index) => {
          const PageComp = tableViews[page] || tableViews[DAILY_FIGURES_TAB_VIEWS.STATUS];
          return (
            <Tab id={currentTableView} key={index} tabActive={page === currentTableView}>
              <PageComp
                dailyFigures={dailyFigures}
                transient={transient}
                getAdminDailyFiguresLoading={getAdminDailyFiguresLoading}
                getAdminDailyFigures={getAdminDailyFigures}
              />
            </Tab>
          );
        })}
      </Tabs>
    </ColumnView>
  );
};

Charity.propTypes = {
  adminDailyFigures: PropTypes.object,
  adminFilters: PropTypes.object,
  getAdminDailyFigures: PropTypes.func,
  transient: PropTypes.object,
  updateDailyFiguresProps: PropTypes.func,
  updateTransientProps: PropTypes.func,
  updateUserProps: PropTypes.func,
  userAdminFilters: PropTypes.object,
  userRole: PropTypes.string,
  view: PropTypes.string
};

export default Charity;
